import { checkImageFormat } from '../../utils.js'
import FacingTypeCardUserSelect from '../FacingTypeCardUserSelect.vue'
import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'facingtype-card-new',
  components: {
    FacingTypeCardUserSelect
  },
  data: () => ({
    showUserSelectModal: false,
    showHeadsUpModal: true,
    selectedUser: {
      id: null,
      attributes: {
        'user-name': '',
        'user-firstname': '',
        'shop-name': '',
        'profile-path': ''
      }
    },
    selectedFrontImageFile: null,
    selectedBackImageFile: null,
    csv: {
      idea_peace_ming: false,
      idea_sincere: false,
      idea_excitement: false,
      idea_comfortable: false,
      idea_creation: false
    },
    esv: {
      idea_civility: false,
      idea_imagination: false,
      idea_sympathy: false,
      idea_expression: false,
      idea_challenge_dream: false
    },
    showErrorFrontImage: false,
    showErrorBackImage: false,
    showCompletedRegisterModal: false,
    savingFlag: false
  }),
  computed: {
    targetUser () {
      return this.$route.name === 'FacingTypeCardGiveNew' ? 'give' : 'get'
    },
    selectedFrontImage () {
      return this.selectedFrontImageFile && URL.createObjectURL(this.selectedFrontImageFile)
    },
    selectedBackImage () {
      return this.selectedBackImageFile && URL.createObjectURL(this.selectedBackImageFile)
    },
    getUserImage () {
      if (this.selectedUser.attributes['profile-path']) {
        return this.selectedUser.attributes['profile-path'] + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      }
      return require('../images/icon_submenu_face.png')
    },
    noSelectedAllRequired () {
      const hasCsv = Object.keys(this.csv).some(key => this.csv[key])
      const hasEsv = Object.keys(this.esv).some(key => this.esv[key])
      return !this.selectedFrontImageFile || !this.selectedUser.id || (!hasCsv && !hasEsv)
    },
    currentUserId () {
      return window.localStorage.getItem('user_id')
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()
      const hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      const min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      const sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  created: function () {
  },
  methods: {
    async registFacingTypeCard () {
      if (this.savingFlag) return
      this.savingFlag = true

      if (this.noSelectedAllRequired) return
      const formData = new FormData()
      formData.append('front_card_path', this.selectedFrontImageFile)
      if (this.selectedBackImageFile) {
        formData.append('back_card_path', this.selectedBackImageFile)
      }
      const getUserId = this.targetUser === 'give' ? this.selectedUser.id : this.currentUserId
      const giveUserId = this.targetUser === 'give' ? this.currentUserId : this.selectedUser.id
      formData.append('get_user_id', getUserId)
      formData.append('give_user_id', giveUserId)
      formData.append('facing_created_user_id', this.currentUserId)
      formData.append('is_already_read', this.targetUser === 'give' ? 0 : 1)
      for (let key in this.csv) {
        formData.append(key, this.csv[key] ? 1 : 0)
      }
      for (let key in this.esv) {
        formData.append(key, this.esv[key] ? 1 : 0)
      }
      this.openLoadingModal() // ローディングオープン
      await this.$store.dispatch('MYCARD_REGIST_FACING_TYPE_CARD', formData)
      await this.closeLoadingModal() // ローディングクローズ
      this.showCompletedRegisterModal = true
    },
    openLoadingModal: function () {
      const button = document.getElementById('loadingModalButton')
      button.click() // モーダル表示 イベント発火
    },
    closeLoadingModal: function () {
      $('#loadingModal').modal('hide')
    },
    selectUser (user) {
      this.selectedUser = user
    },
    selectFrontImage (event) {
      if (!event.target.files.length) return
      const file = event.target.files[0]
      if (!checkImageFormat(file)) {
        this.showErrorFrontImage = true
        return
      }
      this.showErrorFrontImage = false
      this.selectedFrontImageFile = file
    },
    closeFrontImage () {
      this.$refs.frontImageInputRef.value = ''
      this.selectedFrontImageFile = null
    },
    selectBackImage (event) {
      if (!event.target.files.length) return
      const file = event.target.files[0]
      if (!checkImageFormat(file)) {
        this.showErrorBackImage = true
        return
      }
      this.selectedBackImageFile = file
    },
    closeBackImage () {
      this.$refs.backImageInputRef.value = ''
      this.selectedBackImageFile = null
    },
    goMyCardList () {
      const userId = window.localStorage.getItem('user_id')
      this.$router.push({
        path: `/es_mycard_list/${userId}`,
        query: { 'target': this.targetUser }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/facingtype-card-new.js